module.exports = __webpack_public_path__ + "static/media/treasure_dark_blue.8bd45732.svg";